const KITCHEN_STAFFS_TABLE_READY = "kitchenStaffs-table-ready"
const SEARCH_TEXT_STATE = "kitchenStaffs-table-search-text-state"
const ROWS_PER_PAGE_STATE = "kitchenStaffs-table-rows-per-page-state"
const PAGINATION_STATE = "kitchenStaffs-table-pagination-state"

const KITCHEN_STAFF_ID_FOR_ACTION = "kitchenStaffs-table-kitchen-staff-id-for-action"

const ADD_EDIT_KITCHEN_STAFF_READY = "add-edit-kitchen-staff-ready"


const PREVIOUS_KITCHEN_STAFF_FILTER_CITY = "previous-kitchen-staff-filter-city"

const PREVIOUS_KITCHEN_STAFF_FILTER_KITCHEN_ID = "previous-kitchen-staff-filter-kitchen-id-action"



const initialState = {
    isKitchenStaffsTableReady: true,
    isAddEditKitchenStaffReady:true,
    kitchenStaffs: {},

    
    kitchenStaffSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterCity : "",
    previousFilterKitchenId : "",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case KITCHEN_STAFFS_TABLE_READY:
            return Object.assign({}, state, { isKitchenStaffsTableReady: action.payload })
        case ADD_EDIT_KITCHEN_STAFF_READY:
            return Object.assign({}, state, { isAddEditKitchenStaffReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case KITCHEN_STAFF_ID_FOR_ACTION:
            return Object.assign({}, state, {kitchenStaffSelectedId:action.payload})

        case PREVIOUS_KITCHEN_STAFF_FILTER_CITY:
            return Object.assign({}, state, {previousFilterCity:action.payload})

        case PREVIOUS_KITCHEN_STAFF_FILTER_KITCHEN_ID:
            return Object.assign({}, state, {previousFilterKitchenId:action.payload})

        default:
        return state
    
    }

}

export function kitchenStaffTableReady(data) {
    return {
        type: KITCHEN_STAFFS_TABLE_READY,
        payload: data
    }
}


export function addEditKitchenStaffReady(data) {
    return {
        type: ADD_EDIT_KITCHEN_STAFF_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function kitchenStaffIdForAction(kitchenStaffId){
    return{
        type:KITCHEN_STAFF_ID_FOR_ACTION,
        payload:kitchenStaffId
    }
}

export function previousFilterCity(filterVal){
    return{
        type:PREVIOUS_KITCHEN_STAFF_FILTER_CITY,
        payload:filterVal
    }
}


export function previousFilterKitchenId(filterVal){
    return{
        type:PREVIOUS_KITCHEN_STAFF_FILTER_KITCHEN_ID,
        payload:filterVal
    }
}




// WEBPACK FOOTER //
// ./src/modules/Kitchen Staffs/redux/kitchen_staffs.js